 $(".slick-slider").slick({
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 60px;">&#8249;</span></button>',
      nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 60px;">&#8250;</span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 40px;">&#8249;</span></button>',
            nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 40px;">&#8250;</span></button>',
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
      ]
    });

/* blog slider*/

$(document).ready(function() {
  $('.blog-carousel').owlCarousel({
    items: 1, // Default number of items
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    nav: true,
    dots: true,
    responsive: {
      0: { items: 1 },      
      600: { items: 1 },   
      1000: { items: 1 }    
    }
  });
});


/* instagram slider*/


setTimeout(function() {
  console.log('instagram slider here');
jQuery('div#insta-feed .instafeed-new-layout-wrapper').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    nav:false,
    autoplay:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
}, 5000);  







// see-similar-products slider

document.addEventListener('DOMContentLoaded', function () {
  
 if (window.innerWidth < 768) {
    const toggleBtns = document.querySelectorAll('.see-similar-toggle');
    const popup = document.querySelector('.see-similar-container');
  
    toggleBtns.forEach((toggleBtn) => {
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent immediate closing
        popup.classList.toggle('active');
      });
    });
  
    document.addEventListener('click', function (e) {
      
      const clickedOnToggle = Array.from(toggleBtns).some(btn => btn.contains(e.target));
      if (!popup.contains(e.target) && !clickedOnToggle) {
        popup.classList.remove('active');
      }
    });
  }
   $('.similar-slider-products').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: window.innerWidth < 1024,
    autoplaySpeed: 8000,
    prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24"><path d="M15 6l-6 6 6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24"><path d="M9 6l6 6-6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  // AJAX Add to Cart
  document.querySelectorAll('.similar-slider-products .ajax-add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const productId = this.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        localStorage.setItem('openCartDrawer', 'true');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        setTimeout(() => location.reload(), 1000);
      })
      .catch(() => setTimeout(() => location.reload(), 1000));
    });
  });

  // Open cart drawer after reload
  if (localStorage.getItem('openCartDrawer') === 'true') {
    localStorage.removeItem('openCartDrawer');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
});



// pair_it_with_product_metafields slider

document.addEventListener('DOMContentLoaded', function () {
    var autoplayEnabled = window.innerWidth < 1024;
    
    $(".paired-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: autoplayEnabled,
      autoplaySpeed: 8000,
      prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24"><path d="M15 6l-6 6 6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24"><path d="M9 6l6 6-6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

  // AJAX Add to Cart with delayed reload and drawer open
  document.querySelectorAll('.paired-product-slider .ajax-add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const productId = this.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        // Set flag to open drawer after reload
        localStorage.setItem('openCartDrawer', 'true');

        // Optionally open drawer immediately
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Reload after 1 seconds
        setTimeout(() => {
          location.reload();
        }, 1000);
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    });
  });

  // On page load, open cart drawer if flag set
  if (localStorage.getItem('openCartDrawer') === 'true') {
    localStorage.removeItem('openCartDrawer');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
});





// document.addEventListener("DOMContentLoaded", function () {
//   function updateButtons() {
//     const sizeSelect = document.querySelector('.select-product-variant-raj');
//     const selectedSize = sizeSelect?.selectedOptions?.[0];
//     const selectedGold = document.querySelector('input[type="radio"][name="Gold"]:checked');

//     let policy = null;
//     let quantity = null;

//     // Priority: Gold radio, then size dropdown
//     if (selectedGold) {
//       policy = selectedGold.getAttribute('data-inventory-policy');
//       quantity = parseInt(selectedGold.getAttribute('data-inventory-quantity')) || 0;
//     } else if (selectedSize) {
//       policy = selectedSize.getAttribute('data-inventory-policy');
//       quantity = parseInt(selectedSize.getAttribute('data-inventory-quantity')) || 0;
//     }

//     // Hide all buttons first
//     document.querySelectorAll('[id^="ProductSubmitButton-"]').forEach(btn => btn.style.display = 'none');

//     if (!policy) {
//       document.querySelector('.btn-default')?.style.setProperty('display', 'block');
//       return;
//     }

//     if (policy === "continue" && quantity === 0) {
//       document.querySelector('.btn-made-to-order')?.style.setProperty('display', 'block');
//     } else if (policy === "continue" && quantity > 0) {
//       document.querySelector('.btn-add-to-cart')?.style.setProperty('display', 'block');
//     } else if (policy === "deny" && quantity > 0) {
//       document.querySelector('.btn-add-to-cart')?.style.setProperty('display', 'block');
//     } else if (policy === "deny" && quantity === 0) {
//       document.querySelector('.btn-sold-out')?.style.setProperty('display', 'block');
//     } else {
//       document.querySelector('.btn-default')?.style.setProperty('display', 'block');
//     }
//   }

//   // Run on load
//   updateButtons();

//   // Event listeners for dropdown
//   const sizeSelect = document.querySelector('.select-product-variant-raj');
//   sizeSelect?.addEventListener('change', updateButtons);

//   // Event listeners for gold radios
//   document.querySelectorAll('input[type="radio"][name="Gold"]').forEach(radio => {
//     radio.addEventListener('change', updateButtons);
//   });
// });




// document.addEventListener("DOMContentLoaded", function () {
//   const sizeSelect = document.querySelector('select[name="options[Ring size]"]');
//   const goldRadios = document.querySelectorAll('input[name="Gold"]');
//   const madeToOrderBtn = document.querySelector('.btn-made-to-order');
//   const message = document.getElementById("gold-message");

//   function checkInventory() {
//     let sizeContinue = false;
//     let goldContinue = false;

//     // Check size dropdown if it exists
//     if (sizeSelect) {
//       const sizeSelected = sizeSelect.options[sizeSelect.selectedIndex];
//       const sizePolicy = sizeSelected?.dataset.inventoryPolicy;
//       const sizeQuantity = sizeSelected?.dataset.inventoryQuantity;
//       sizeContinue = sizePolicy === "continue" && sizeQuantity === "0";
//     }

//     // Check gold radio buttons if any selected
//     const goldSelected = document.querySelector('input[name="Gold"]:checked');
//     if (goldSelected) {
//       const goldPolicy = goldSelected.dataset.inventoryPolicy;
//       const goldQuantity = goldSelected.dataset.inventoryQuantity;
//       goldContinue = goldPolicy === "continue" && goldQuantity === "0";
//     }

//     // Show or hide message and button
//     if (sizeContinue || goldContinue) {
//       message?.style.setProperty("display", "block");
//       madeToOrderBtn?.style.setProperty("display", "inline-block");
//       madeToOrderBtn?.style.setProperty("background-color", "#8a9577");  
//       madeToOrderBtn?.style.setProperty("color", "#fff", "important");  
//       document.querySelector('.shopify-payment-button').style.display="none";
//     } else {
//       message?.style.setProperty("display", "none");
//       madeToOrderBtn?.style.setProperty("display", "none");
//       madeToOrderBtn?.style.setProperty("background-color", "transparent");
//       madeToOrderBtn?.style.setProperty("color", "#8a9577", "important");  
//       document.querySelector('.shopify-payment-button').style.display="block"
      
//     }
//   }

//   // Attach listeners only if elements exist
//   sizeSelect?.addEventListener("change", checkInventory);
//   goldRadios.forEach(radio => radio.addEventListener("change", checkInventory));

//   // Initial check
//   checkInventory();
// });











// Accordion functionality (toggle only on click)
document.querySelectorAll('.offer-header').forEach(header => {
  header.addEventListener('click', () => {
    const body = header.nextElementSibling;
    const icon = header.querySelector('.toggle-icon');

    // Toggle logic
    if (body.style.display === 'flex') {
      body.style.display = 'none';
      icon.classList.remove('active');
      icon.innerHTML = '&#10094;'; // down arrow
    } else {
      body.style.display = 'flex';
      icon.classList.add('active');
      icon.innerHTML = '&#10094;'; // up arrow
    }
  });
});

// Copy button functionality
document.querySelectorAll('.copy-btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const code = btn.previousElementSibling.textContent;
    navigator.clipboard.writeText(code).then(() => {
      alert(`Code "${code}" copied!`);
    });
  });
});






/*shopbyshape slider*/ 


 